module.exports = __webpack_public_path__ + "static/media/instagram-relax-tabletPro.4049bed8.webp";